import { BackupAction } from './plan-backup-actions-model';

export class BackupActionPre extends BackupAction {
  public TerminateOnFailure: boolean;
  constructor() {
    super();
  }
}
